import React, { useEffect, useState } from 'react';
import { API_KEY ,imageUrl} from '../../constants/Constants'; // Import API_KEY from constants
import axios from '../../axios';
import './Banner.css';
import YouTube from 'react-youtube'

function Banner() {
  const [movie, setMovie] = useState()
  const [url,seturl]=useState('')
  useEffect(() => {
    axios.get(`trending/all/week?api_key=${API_KEY}&language=en-US`).then((response) => {
      console.log(response.data.results[2]);
      const num=Math.floor(Math.random(response.data) * 10);
      setMovie(response.data.results[num]);
    });
  }, []);

  const MovieTrailer =(id)=>{
    axios.get(`movie/${id}/videos?api_key=${API_KEY}&language=en-US`).then((response)=>{
      seturl(response.data.results[0])

    })
    }

    const opts = {
      height: '390',
      width: '100%',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
      },
    };

  return (
    <div className='bannerconatiner'>
    <div 
    style={{backgroundImage:`url(${movie ? imageUrl+movie.backdrop_path:''})`}}
      className='banner'>
      <div className='content'>
        <h1 className='title'>{movie ? movie.title : ''}</h1>
        <div className='banner_button'>
          <button onClick={()=>{
            console.log("Button Clicked");
            MovieTrailer(movie.id)


          }} className='button'>play</button>
          <button className='button'>My list</button>
          
        </div>
        
        <h1 className='description'>{movie ? movie.overview:''}</h1>
        
      </div>
      
      <div className="fade"></div>
      

      
    </div>
    {url && <YouTube opts={opts} videoId={url} />}

    </div>
    
  );
}

export default Banner;
